<template>
	<div>
		<div class="policy">
			<div class="main-title">
				国家重点支持的高新技术领域
			</div>
			<div class="flex flex-end clearfix">
				<el-button type="primary" @click="goback()">返回</el-button>
			</div>
			<div class="detail-content">
				<div data-v-bbdef3ee="" class="detail-content">
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										><strong>一、电子信息</strong></span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（一）软件</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 基础软件</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>服务器/客户端操作系统；通用及专用数据库管理系统；软件生命周期的开发、测试、运行、运维等支撑技术，以及各种接口软件和工具包/组、软件生成、软件封装、软件系统管理、软件定义网络、虚拟化软件、云服务等支撑技术；中间件软件开发技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 嵌入式软件 </span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>嵌入式图形用户界面技术；嵌入式数据库管理技术；嵌入式网络技术；嵌入式软件平台技术；嵌入式软件开发环境构建技术；嵌入式支撑软件生成技术；嵌入式专用资源管理技术；嵌入式系统整体解决方案设计技术；嵌入式设备间互联技术；嵌入式应用软件开发技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 计算机辅助设计与辅助工程管理软件</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>用于工程规划、工程管理/产品设计、开发、生产制造等的软件工作平台或软件工具支撑技术；面向行业的产品数据分析和管理软件；基于计算机协同工作的辅助设计软件；快速成型的产品设计和制造软件；专用计算机辅助工程管理/产品开发工具支撑技术；产品全生命周期管理（PLM）系统软件；计算机辅助工程（CAE）相关软件；分布式控制系统（DCS)、数据采集与监视控制系统（SCADA)、执行制造系统（MES）技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 中文及多语种处理软件</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>中文、外文及少数民族文字的识别、处理、编码转换与翻译技术；语音识别与合成技术；文字手写/语音应用技术；多语种应用支撑技术；字体设计与生成技术；字库管理技术；支撑古文字、少数民族文字研究的相关技术；支撑书法及绘画研究的相关技术；语言、音乐和电声信号的处理技术；支撑文物器物、文物建筑研究的相关技术；支撑文物基础资源的信息采集、转换、记录、保存的相关技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 图形和图像处理软件</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于内容的图形图像检索及管理软件；基于海量图像数据的服务软件；多通道用户界面技术；静态图像、动态图像、视频图像及影视画面的处理技术；人机交互技术；裸眼3D内容制作技术；3D图像处理技术；3D模型原创性鉴定技术；遥感图像处理与分析技术；虚拟现实与现实增强技术；复杂公式图表智能识别转换技术；位图矢量化技术和工程文件智能化分层管理技术；实现2D动画和3D动画的自主切换和交互技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>6. 地理信息系统（GIS）软件</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>网络环境下多系统运行的GIS软件平台构建技术；组件式和可移动应用的GIS软件包技术；基于3D和动态多维的地理信息系统（GIS）平台构建技术；面向地理信息系统（GIS）的空间数据库构建技术；电子通用地图构建技术；地理信息系统（GIS）行业应用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">7. 电子商务软件</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>电子商务支撑/服务平台构建技术；第三方电子商务交易、事务处理、支付服务等支撑与应用技术；行业电子商务、基于云计算的电子商务、移动电子商务支撑与协同应用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">8. 电子政务软件</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>电子政务资源、环境、服务体系构建技术；电子政务流程管理技术；电子政务信息交换与共享技术；电子政务决策支持技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">9. 企业管理软件</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>企业资源计划（ERP）软件；数据分析与决策支持的商业智能（BI）软件；基于RFID和GPS应用的现代物流管理软件；企业集群协同的供应链管理（SCM）软件；基于大数据和知识管理的客户关系管理（CRM）软件；基于互联网/移动互联网的企业资源协同管理技术；跨企业/跨区域供应链/物流管理技术；个性化服务应用技术；商业智能技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">10. 物联网应用软件</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于通信网络和无线传感网络的物联网支撑平台构建技术；基于先进条码自动识别、射频标签、多种传感信息的智能化信息处理技术；物联网海量信息存储与处理技术；物联网行业应用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>11. 云计算与移动互联网软件</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>虚拟化软件；分布式架构和数据管理软件；虚拟计算资源调度与管理软件；云计算环境下的流程管理与控制软件；基于移动互联网的信息采集、分类、处理、分析、个性化推送软件；移动互联网应用软件；大数据获取、存储、管理、分析和应用软件；人工智能技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>12. Web服务与集成软件</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>Web服务发现软件；Web服务质量软件；Web服务组合与匹配软件；面向服务的体系架构软件；服务总线软件；异构信息集成软件；工作流软件；业务流程管理与集成软件；集成平台软件等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（二）微电子技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 集成电路设计技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>集成电路辅助设计技术；集成电路器件模型、参数提取以及仿真工具等专用技术和工艺设计技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 集成电路产品设计技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型通用与专用集成电路产品设计技术；集成电路设备技术;高端通用集成电路芯片CPU、DSP等设计技术；面向整机配套的集成电路产品设计技术；用于新一代移动通信和新型移动终端、数字电视、无线局域网的集成电路设计技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">3. 集成电路封装技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>小外形封装（SOP）、塑料方块平面封装（PQFP）、有引线塑封芯片载体（PLCC）等高密度塑封技术；新型封装技术；电荷耦合元件(CCD)/微机电系统（MEMS）特种器件封装工艺技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">4. 集成电路测试技术 </span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>集成电路测试技术；芯片设计分析与验证测试技术，以及测试自动连接技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 集成电路芯片制造工艺技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>MOS工艺技术、CMOS工艺技术、双极工艺技术、BiCMOS工艺技术、HKMG工艺技术、FinFET工艺技术，以及各种与CMOS兼容的SoC工艺技术；宽带隙半导体基集成电路工艺技术；GeSi
										/SoI基集成电路工艺技术；CCD图像传感器工艺技术；MEMS集成器件工艺技术；高压集成器件工艺技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>6. 集成光电子器件设计、制造与工艺技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>半导体大功率高速激光器、大功率泵浦激光器、超高速半导体激光器、调制器等设计、制造与工艺技术；高速PIN和APD模块、阵列探测器、光发射及接收模块、非线性光电器件等设计、制造与工艺技术；平面波导器件（PLC）液晶器件和微电子机械系统（MEMS）器件的设计、制造与工艺技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（三）计算机产品及其网络应用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 计算机及终端设计与制造技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>台式计算机、便携式计算机、专用计算机、移动终端、终端设备及服务器的设计与制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 计算机外围设备设计与制造技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>计算机外围设备及其关键部件的设计与制造技术；计算机存储设备、移动互联网设备、宽带无线接入设备的设计与制造技术；基于标识管理和强认证技术；基于视频、射频的识别技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 网络设备设计与制造技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>无线收发技术；高性能网络核心设备、网络传输和接入设备、TD-LTE设备等设计与制造技术，以及智能家居、可穿戴式电子设备等融合型设备设计与制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">4. 网络应用技术 </span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于标准协议的信息服务管理和网络管理软件的关键技术；ISP、ICP的增值业务软件和应用平台的关键技术；网络融合技术；网络增值业务应用技术；网络服务质量与运营管理技术；可信网络管理技术；移动智能终端应用技术；TD-LTE应用技术；数字媒体内容平台/内容分发网络（CDN）技术；网络资源调度管理技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（四）通信技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 通信网络技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>光传送网络、宽带无线移动通信网络、宽带卫星通信网络、微波通信网络、IP承载网络的组网与规划、控制管理、交换、测试、节能等技术；三网融合通信技术；光网络核心节点和边缘节点及其关键模块/器件设计与制造技术；核心路由器和边缘路由器及其关键模块/器件设计与制造技术；软交换技术；SDN技术；IPv6技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 光传输系统技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型光传输设备技术；新型光接入设备和系统技术；新型低成本小型化波分复用传输设备和系统技术；新型关键模块光传输系统仿真计算等专用软件技术；高速光传输技术；超大容量复用技术；可变带宽光传输技术；多业务传送平台技术；低能耗光传输技术；自由空间光传输技术；光传输测试技术；光传输关键模块/器件设计与制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 有线宽带接入系统技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>FTTx光纤接入技术；混合光纤同轴电缆网（HFC）接入技术；无源光网络接入技术及其控制管理技术；三网融合接入技术；新型综合接入技术；宽带有线接入测试技术；有线宽带接入关键模块/器件设计与制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">4. 移动通信系统技术 </span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>宽带移动通信基站技术；宽带移动系统交换、控制管理、基站互连、拉远传输、分布式覆盖、测试等技术；宽带移动通信终端技术；智能天线技术；宽带移动通信关键模块/器件设计与制造技术；数字集群系统的配套技术；其他基于移动通信网络的行业应用的配套技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 宽带无线通信系统技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>宽带无线接入系统技术；宽带无线应用终端技术；低能耗宽带无线通信技术；宽带无线通信测试技术；宽带无线通信行业应用技术；无线数字集群通信技术；宽带无线通信关键模块/器件设计与制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">6. 卫星通信系统技术 </span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>卫星通信转发器及其控制管理与电源技术；卫星地面站系统及其控制管理技术；卫星通信天线馈线、发射接收、信道终端、测试、应用等技术；卫星通信应用终端技术；卫星定位与导航应用技术；卫星遥感数据共享与应用技术；卫星通信关键模块/器件设计与制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">7. 微波通信系统技术 </span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型微波通信系统技术；微波通信天线馈线、发射接收、测试、应用等技术；微波应急通信系统技术；微波通信系统关键模块/器件设计与制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>8. 物联网设备、部件及组网技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>面向物联网应用的M2M终端、通信模块和网关等设备和部件的设计与制造技术；物联网组网技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>9. 电信网络运营支撑管理技术
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于固网、宽带移动网及其混合网络的电信网络运营支撑管理技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>10. 电信网与互联网增值业务应用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于固网、宽带移动网、互联网及其混合网络的增值业务应用平台技术及其中间件技术；电信网络增值新业务应用技术、互联网+的业务应用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（五）广播影视技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 广播电视节目采编播系统技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>与数字电视系统相适应的广播电视节目采集、编辑、制作与播出技术；节目制播网设备与软件的关键支撑技术；面向数字媒体版权保护的加解密和密钥管理的关键支撑技术；电台、电视台自动化网络化技术、云制作技术与大数据分析技术；数字媒体内容存储转发及检索交互技术；系统规划与系统集成、音视频质量测试评估技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 广播电视业务集成与支撑系统技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>数字电视广播业务集成系统、条件接收系统、用户管理系统等支撑技术；电子节目指南（EPG）及数据业务相关系统的支撑技术；交互数字电视业务集成和用户认证系统的支撑技术；IPTV、互联网电视、手机电视等业务集成播控平台技术；内容聚合技术，云平台技术和大数据应用分析技术；可用于多终端的自适应编码系统的支撑技术；跨域服务运营支持系统的支撑技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 有线传输与覆盖系统技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>可用于有线电视宽带网络骨干网、城域网的新型光传输设备技术，支持高清、超高清、3D业务的内容分发设备技术；FTTH和EoC等宽带接入设备技术，数字家庭网络设备、智慧城市设备技术，多业务融合终端和智能电视操作系统与智能终端和智能家庭媒体网关技术；用户收视行为调查与分析技术；可用于有线电视宽带网络的运营支撑管理系统及大数据分析技术；网络优化、系统集成和测试评估技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 无线传输与覆盖系统技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>地面数字电视传输系统技术；用于数字声音广播传输系统技术；调频/调幅同步广播系统技术；应急广播系统技术；智能接收天线和多业务融合终端技术；无线传输与覆盖频率规划、系统集成、发射台站自动化管理、电磁防护和测试评估技术；用于广播电视卫星传输系统的编码复用加扰系统技术、调制上变频及高功放系统、天馈线系统技术等；卫星直播内容分发系统和用户管理系统技术；广播电视专业卫星综合接收解码技术及测试评估技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 广播电视监测监管、安全运行与维护系统技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>中短波广播、调频广播、有线数字电视、地面数字电视、数字声音广播、卫星直播系统等广播电视业务技术、频谱监测设备技术；IPTV、手机电视、互联网电视、互联网音视频等视听新媒体内容监管设备和内容甄别分析软件技术；广播电视节目安全播出技术服务系统及信息安全测评技术；新媒体视听节目的监测、监控、监管技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">6. 数字电影系统技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>数字电影专业级拍摄设备及数字成像技术；数字电影虚拟摄影、计算机图形图像制作（CG/CGI）、动作捕捉、虚拟现实与增强现实（VR/AR）制作技术；数字电影前后期制作、存储、传输与放映技术；数字电影网络化分布式协同制作云服务技术；数字电影声音制作与还原技术；电影放映信息化与智能化技术；新一代数字电影版权保护技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">7. 数字电视终端技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型数字电视系统技术；三维电视系统技术；超高清电视系统技术；移动多媒体电视系统技术；智能电视嵌入式应用技术；数字电视安全系统技术；多种传输方式融合的数字电视终端技术；新型投影技术；数字电视终端关键模块/器件设计与制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>8. 专业视频应用服务平台技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>智能化、网络化视频监控平台技术；跨平台、跨领域数字内容服务与应用平台技术；多业务应用平台技术；高清、宽动态、低照度摄像技术；大容量、高压缩监控后端处理技术；面向视频服务的云存储系统技术；电视屏幕、手机屏幕、电脑屏幕互动与融合技术；视频应用服务内容保护技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">9. 音响、光盘技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高保真音响器件与系统技术；高保真音源技术；专业数字音响系统技术；大容量、可刻录、三维播放、高保真的新型光盘技术；音响、光盘关键模块/器件设计与制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（六）新型电子元器件</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 半导体发光技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高效率、高亮度、低衰耗、抗静电的外延片生长技术；大功率、高效率、高亮度、低衰耗、抗静电的发光二极管制造技术；半导体照明用、长寿命、高效率的荧光粉材料；半导体照明用、高可靠、长寿命的驱动电源技术；低衰耗、热匹配性能和密封性能好的封装树脂材料和热沉材料技术；其他高效率、高亮度、低衰耗半导体发光技术；与半导体照明相关的智能控制、光通信技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 片式和集成无源元件</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高可靠片式元器件、片式EMI/EMP复合元件和LTCC集成无源元件制造技术；片式高温、高频、大容量多层陶瓷电容器（MLCC）制造技术；片式NTC、PTC热敏电阻和片式多层压敏电阻技术；片式高频、高稳定、高精度频率器件制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">3. 大功率半导体器件</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高可靠、长寿命、低成本VDMOS垂直栅场效应晶体管制造技术；绝缘栅双极型功率管（IGBT）；用于大型电力电子成套装置的集成门极换流晶闸管（IGCT）制造技术；其他新机理的大功率半导体器件制造技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">4. 专用特种器件</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高可靠微波器件、抗幅照器件制造技术，其他新机理的专用特种器件制造技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 敏感元器件与传感器</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于新原理、新材料、新结构、新工艺的敏感元器件的传感器与工艺技术；采用半导体、陶瓷、金属、高分子、超导、光纤、纳米等材料以及复合材料的传感器与工艺技术；多功能复合传感器与工艺技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">6. 中高档机电组件</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>超小型、高可靠、高密度的高速连接器制造技术；新型高可靠通信继电器制造技术；小型化组合式大电流继电器制造技术；高可靠固体光/MOS继电器制造技术；高保真、高灵敏、低功耗电声器件制造技术；刚挠结合板和HDI高密度积层板技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">7. 平板显示器件</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>大屏幕液晶显示（TFT-LCD）、等离子显示（PDP）、场致发光显示（FED）、硅基液晶（LCoS）显示、有机发光二极管（OLED）显示等新型平板显示器件技术及相关的光学引擎技术；长寿命、高亮度投影技术；裸眼3D膜技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（七）信息安全技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 密码技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>加解密技术；密码认证技术；数据完整性保护技术；数字签名技术；密钥管理技术；密码芯片技术；基于密码技术的集成化应用技术；数字水印技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 认证授权技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>电子认证技术；生物认证技术；身份管理技术；数字版权保护技术；访问控制技术；授权件安全技术管理技术；网络信任技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 系统与软件安全技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>硬件和固件安全技术；工控系统安全技术；操作系统和数据库安全技术；可信计算技术；中间件安全技术；应用软件安全技术；云计算安全技术；大数据安全技术；密文数据库技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 网络与通信安全技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>网络与通信攻击检测及防护技术；网络边界安全防护技术；恶意代码分析与防护技术；网络监测/监控技术；网络安全审计技术；网络与通信安全预警技术；网络与通信安全协议技术；安全接入技术；网络内容安全管理技术；移动通信安全技术；宽带无线安全技术；卫星通信安全技术；物联网安全技术；RFID安全技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">5. 安全保密技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>网络信息防失窃泄密技术；安全隔离与交换技术；数据单向导入技术；屏蔽、抑制与干扰防护和检测技术；电子文档安全管理技术；存储介质中信息的安全防护技术；数据恢复技术；数据销毁及检测技术；安全保密检查技术；文化、文物及文物衍生产品防伪技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">6. 安全测评技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>网络与信息系统安全性能测试、评价与风险评估技术；安全态势评估与预测技术；安全产品测评技术；等级保护、分级保护测评技术；安全可控性仿真验证技术；认证、认可管理支撑技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">7. 安全管理技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>安全集中管理、控制与审计分析技术；面向网络日志、报警、流量等数据的安全综合分析与管理技术；安全策略和安全控制措施配置、分发及审核的管理技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">8. 应用安全技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>电子政务和电子商务应用安全技术；公众信息服务应用安全技术；数字取证、分析与证据保全技术；终端安全应用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 低水平、应用前景不明的技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（八）智能交通和轨道交通技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 交通控制与管理技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>具备可扩展性的信号控制技术；可支持多种下端协议的上端控制与管理系统的软件和专用硬件技术；网络环境下交通数据综合接入设备技术；交通事件自动检测和事件管理软件技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 交通基础信息采集、处理技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>交通量遥测技术；设施状况及交通环境感知技术；车辆身份照识别技术；营运车辆安全状态检测技术；交通基础设施状态监测技术；交通专用传感器网络技术；内河船舶交通量自动检测技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 交通运输运营管理技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>支持多种支付方式的自动售检票系统技术；路网运行监测和应急处置技术；综合交通枢纽调度和应急指挥技术；多车道自动收费管理技术；多模式运输组织与管理技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 车、船载电子设备技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>车、船载动态信息导航技术；车、船载安全驾驶辅助技术；车、船载信息管理技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 轨道交通车辆及运行保障技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>轨道交通列车在途状态检测与预警技术；轨道交通车载传感网技术；轨道交通列车运行安全保障与运维支持一体化技术；轨道交通列车牵引传动、制动与控制技术；轨道交通列车安全防护与控制技术；轨道交通列车自动运行等技术；轨道交通列车关键部件设计与制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>6. 轨道交通运营管理与服务技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>轨道交通车-地数据传输技术；轨道交通移动通信广域网、局域网技术；轨道交通安全苛求数据可信传输技术；终端综合检测技术；新型车地一体化综合公共信息网络平台技术；轨道交通基础设施状态检测与数据管理技术；列车运行实时控制与指挥技术；轨道交通运行综合调度指挥技术；轨道交通系统运行故障检测、预警与应急处置技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										><strong>二、生物与新医药</strong></span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（一）医药生物技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 新型疫苗</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型高效基因工程疫苗、联合疫苗、减毒活疫苗研发技术；重大疾病和重大传染病治疗性疫苗技术；疫苗生产所使用新型细胞基质、培养基以及大规模培养生产的装备开发技术；疫苗生产所使用的新型佐剂、新型表达载体/菌（细胞）株开发技术；疫苗的新型评估技术、稳定和递送技术；针对突发传染病的疫苗快速制备和生产技术；其他基于新机理的新型疫苗技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 生物治疗技术和基因工程药物</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基因治疗技术；基因工程药物和基因治疗药物技术；基因治疗药物的输送系统技术；重组蛋白、靶向药物、人源化及人源性抗体药物制剂研制技术；单克隆抗体规模化制备集成技术和工艺；新型免疫治疗技术；新型细胞治疗技术；疾病治疗的干细胞技术；小RNA药物开发技术；降低免疫原性的多肽的新修饰技术；ADC抗体偶联药物研制及工程细胞株建库技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">3. 快速生物检测技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>重大疾病和重大传染病快速早期检测与诊断技术；新型基因扩增(PCR)诊断试剂及检测试剂盒制备技术；新一代测序技术与仪器开发技术；生物芯片技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 生物大分子类药物研发技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>蛋白及多肽药物研究与产业化技术；细胞因子多肽药物开发技术；核酸及糖类药物研究与产业化技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 天然药物生物合成制备技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>生物资源与中药资源的动植物细胞大规模培养技术；基因工程与生物法生产濒危、名贵、紧缺药用原料技术；生物活性物质的生物制备、分离提取及纯化技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>6. 生物分离介质、试剂、装置及相关检测技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>专用高纯度、自动化、程序化、连续高效的装置、介质和生物试剂研制技术；新型专用高效分离介质及装置、新型高效膜分离组件及装置、新型发酵技术与装置开发技术；生物反应和生物分离的过程集成技术与在线检测技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（二）中药、天然药物</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 中药资源可持续利用与生态保护技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>中药材优良品种选育、品系提纯复壮的新方法、新技术；珍稀、濒危野生动植物药材物种的种源繁育、规范化种植或养殖及生态保护技术；中药材规范化种植或养殖技术；中药材饮片炮制技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 创新药物研发技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型天然活性单体成分提取分离纯化技术；新药材、新药用部位、新有效成分的新药研发技术；能显著改善某一疾病临床终点指标的新中药复方研发技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 中成药二次开发技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>显著改善传统或名优中成药安全性、有效性、质量均匀性或能显著降低用药剂量、提高患者依从性、降低疾病治疗成本的新工艺技术及新中药制剂技术；突破中药传统功能主治范围的新适应症研发技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 中药质控及有害物质检测技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>中药产品质量控制的标准物质研制技术；中药产品标准新型控制技术；新型有效质控检测方法技术；有害物质检测技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（三）化学药研发技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 创新药物技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于新化学实体、新晶型、新机制、新靶点和新适应症的靶向化学药物及高端制剂的创制技术；提高药物安全性、有效性与药品质量的新技术；已有药品新适应症开发技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 手性药物创制技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>手性药物的化学合成、生物合成和拆分技术；手性试剂和手性辅料的制备和质量控制技术；手性药物产业化生产中的质量控制新技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">3. 晶型药物创制技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于化学药物或天然药物的晶型物质的发现、制备、检测和评价技术；晶型药物的原料药物或制剂中的晶型物质制备、生产及质量控制技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 国家基本药物生产技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>显著提高国家基本药物药品质量与临床疗效或降低毒副作用、减少环境污染与生产成本的技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 国家基本药物原料药和重要中间体的技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>具有高附加值、高技术含量、市场需求量大并属国家基本药物的活性化学成分、重要中间体的生产技术；大幅度减少环境污染、节能降耗并显著降低生产成本的药物及医药中间体或晶型原料的技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（四）药物新剂型与制剂创制技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 创新制剂技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>提高药物临床疗效、减少给药次数、降低不良反应的各种给药途径的创新制剂技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 新型给药制剂技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>主动或被动靶向定位释药制剂技术；缓控释及靶向释药制剂技术；微乳、脂质体及纳米给药技术；透皮和定向释药技术等新型给药技术；蛋白类或多肽类等生物技术药物的特定释药载体与口服给药制剂技术；长效注射微球制剂技术；吸入给药制剂技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 制剂新辅料开发及生产技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>提高生物利用度的制剂辅料开发及应用技术；难溶性药物增溶的关键技术、新型口腔速溶制剂的技术；新型制剂辅料产业化生产技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">4. 制药装备技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>制药产业化自动生产线及在线检测和自动化控制技术；新型药物制剂工业化专用生产装备技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（五）医疗仪器、设备与医学专用软件</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 医学影像诊断技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>临床诊断的新型数字成像技术；多模态医学影像融合成像与处理技术；专用新型彩色超声诊断技术；人体内窥镜的微型摄像技术；新型病理图像识别与分析技术；新型医学影像立体显示关键技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 新型治疗、急救与康复技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>肿瘤治疗的新型立体放射治疗技术；影像引导治疗与定位、植入、介入及计算机辅助导航技术；急救及康复的新型装置与技术；生物3D打印技术；组织工程及再生医学治疗技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 新型电生理检测和监护技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>电生理检测和监护的新型数字化技术；临床、社区、康复的新型无创或微创的检测或诊断、监护和康复技术；远程、移动监护的高灵敏高精度传感技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 医学检验技术及新设备</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>生化分析的新型自动化、集成化技术；便携式现场应急生化检验检测技术；采用新工艺、新方法或新材料有明确临床诊断价值的医学检验技术；临床医学生理、生化、病理检验的专用多功能快速检测装置与技术；国产化新型色谱制备分析装置技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 医学专用网络新型软件</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>电子病历管理、临床医疗信息管理、医院信息管理、专科临床信息管理、电子健康档案管理的新型软件系统开发技术；手术规划、放疗规划等新型医疗决策支持系统开发技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>6. 医用探测及射线计量检测技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>CT高分辨探测器、DR数字探测器、X射线机高压电源的装置技术；微焦斑与高功率的高分辨X射线管新型装置技术；医用高性能超声探头技术；放射治疗的射线计量检测技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（六）轻工和化工生物技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 高效工业酶制备与生物催化技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高效工业酶制剂的新型制备技术；酶纯化、酶固定化与反应器应用技术；工业酶分子改造技术；重要化学品的生物合成和生物催化技术；纺织天然纤维脱胶脱脂、纺织印染低温前处理生物酶技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 微生物发酵技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新功能微生物选育与发酵过程的优化控制技术；高发酵率的代谢工程技术；可提高资源利用率、节能减排、降低成本的微生物发酵新工艺和技术；微生物固定化发酵与新型反应器的开发技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 生物反应及分离技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>工业生物产品的大规模高效分离、分离介质和分离设备开发技术；高效生物反应过程在线检测和过程控制技术；生物反应过程放大技术及新型生物反应器开发技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 天然产物有效成份的分离提取技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>从天然动植物中提取有效成份制备高附加值精细化学品的分离提取技术；天然产物有效成份的全合成、化学改性及深加工新技术；高效分离纯化技术集成及装备的开发与生产技术；从动植物原料加工废弃物中分离提取有效成份的新技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 食品安全生产与评价技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>功能性食品有效功能的评价技术；新食品原料安全评价技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">6. 食品安全检测技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>食品中微生物、生物毒素、农药兽药残留快速检测技术及检测产品开发技术；食品质量快速检测技术及食品掺假快速识别检测技术；食品中重金属成分快速检测技术；食品原料快速溯源技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 单纯检测技术应用除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（七）农业生物技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 农林植物优良新品种与优质高效安全生产技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>优质、高产、高抗逆性优良新品种选育技术；用于优质高效安全生产的新型肥料、农药、土壤改良材料和植物生长调节剂生产技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 畜禽水产优良新品种与健康养殖技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>畜禽水产优良新品种及快繁技术；珍稀动物、珍稀水产保种与养殖技术；畜禽水产业健康养殖屠宰加工的环境调控、废弃物循环利用、死亡动物无害化处理技术；安全、优质、专用新型饲料、饲料添加剂、兽用药物及制剂、兽用疫苗、天然药物提取物及生物合成制备生产技术；畜牧水产业质量安全监控、评价、检测技术；海洋生物资源发掘与筛选新技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 重大农林生物灾害与动物疫病防控技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>重大农林病虫鼠草害、重大旱涝等灾害以及森林火灾的监测预警与防控减灾技术；主要植物病虫害和畜禽水产重大疾病的监测预警、快速诊断、应急处理及抗药性检测技术；高效安全环保农药、兽药的创制、生产与质量监测技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 现代农业装备与信息化技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型农作物、牧草、林木种子的收获、精选、加工、质量检测技术；新型农田作业机械、设施农业技术；新型畜禽、水产规模化养殖技术；农业生产过程监测、控制及决策系统与技术；精准农业、遥感与农村信息化服务系统与技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 农业面源和重金属污染农田综合防治与修复技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>农田氮磷面源污染防控技术；农田农药污染防控技术；重金属污染农田修复技术；重金属污染耕地安全利用与替代种植技术；农业有机废弃物消纳利用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										><strong>三、航空航天</strong></span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（一）航空技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 飞行器</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>总体综合设计技术：飞行器外形设计、气动布局、动力装置与飞机的一体化设计、载荷设计、飞行器进排气系统设计等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>空气动力技术：气动力设计、气动力试验、计算流体力学、气动噪声设计、水动力设计等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>结构/强度技术：结构设计、起落装置设计、强度设计和验证设计、疲劳设计和验证设计、热强度设计和验证设计等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 飞行器动力技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>总体综合设计技术：总体性能与结构设计、强度计算、气动热力设计、噪声控制等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>部件技术：核心机设计、发动机进排气装置、燃烧室、涡轮等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>动力系统技术：控制系统、起动点火系统、空气系统与封严等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">3. 飞行器系统技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>飞行控制系统技术：飞控总体设计、飞行器管理系统、自动飞行控制、飞控传感器、无人机的遥控等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>航电与任务系统技术：航电系统总体综合、射频与光电探测、通信/识别/监视、综合导航、综合任务管理系统等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>机电与公共系统技术：机电系统总体综合、电力系统与多电/全电系统、辅助动力系统、液压系统、燃油系统、防/除冰系统、机轮刹车系统等技术。
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 飞行器制造与材料技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>制造技术：数控和柔性制造系统加工、精密/超精密和微细加工、塑性成型加工与扩散连接、精密铸造、智能/数字化装配技术；复合材料构件制造等技术。
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>材料技术：新型材料母合金/原材料的制备、新型材料的先进生产及加工、航空材料的相关力学性分析和测试等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">5. 空中管制技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>通信、导航、监视及航空交通管理系统（CNS/ATM）管制工作站系统技术；CNS/ATM网关系统技术；飞行流量管理系统和自动化管制系统等技术；数字化放行（PDC）系统技术；自动终端信息服务（D-ATIS）系统技术；空中交通进离港排序辅助决策系统技术；空管监视数据融合处理系统技术；飞行计划集成系统技术；卫星导航地面增强系统技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>6. 民航及通用航空运行保障技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型民用航空综合性公共信息网络平台、安全管理系统、天气观测和预报系统、适航审定系统等技术；新型先进的机场安全检查系统、货物及行李自动运检系统、机场运行保障系统等技术；民用雷达技术，地面飞行训练系统技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（二）航天技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 卫星总体技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>卫星总体设计、大型试验设计和实施技术，以及结构、热控、综合电子等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 运载火箭技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>运载火箭总体优化设计技术；运载火箭系统冗余、高空风双向补偿减载、飞行振动抑制、火箭起飞滚转定向、一箭多星发射、MEO卫星发射轨道设计、主动章动控制的自旋稳定、全箭振动试验动特性获取、空射火箭动基座对准等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">3. 卫星平台技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>大型、高姿态稳定度、大轨道机动能力、长寿命和高可靠性卫星平台技术；小型化/微型化卫星、多功能复合结构设计、卫星热控设计、卫星电源和新型推进、卫星综合电子、空间碎片防护、空间环境安全保障等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">4. 卫星有效载荷技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>通信有效载荷技术：大容量转发器、频率复用、毫米波/激光星间链路、大功率行波管放大器、大型可展开天线、星上交换处理、综合抗干扰、卫星自主生存等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>导航有效载荷技术：高稳定星载原子钟、星间链路、自主导航、先进的导航信号调制、导航信号自主完好性监测、时空域抗干扰、区域增强天线、高精度测距、上行注入抗干扰、高精度时间同步和传递等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>遥感有效载荷技术：甚高分辨率可见光相机，高分辨率红外相机，集成大焦面电子学及信息处理、高光谱/超光谱成像、辐射定标与光谱定标、毫米波/亚毫米波辐射计、综合孔径微波辐射计、全极化微波辐射计、合成孔径雷达、测云/降雨雷达等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>空间科学有效载荷技术：低功耗、高分辨率探测器技术、小型化及载荷集成、大型光学系统、紫外探测仪、激光测距仪等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">5. 航天测控技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>地球轨道卫星测控技术；航天信息传输技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>6. 航天电子与航天材料制造技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>空间微电子和空间计算机技术，空间传感器及机电组件技术；先进动力系统材料、轻质化结构材料、热防护材料以及特殊环境服役的新型材料等制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>7. 先进航天动力设计技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>火箭发动机总体技术；火箭发动机涡轮泵及阀门技术；固体主发动机过载下内绝热技术；吸气式组合循环发动机方案与验证技术；电推进及特种发动机关键技术；先进试验技术；先进推进剂技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">8. 卫星应用技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>遥感全链路成像机理、应用仿真及多源遥感数据的高频次、高精度、高时效辐射定标技术；大气探测激光雷达、陆地生态系统、重力场测量等新型载荷数据处理及应用技术；星地一体化多网接入组网仿真、宽窄带通信业务一体化应用技术；基于卫星通信、导航、遥感的天地一体化综合应急反应服务技术；卫星与物联网、云计算、大数据等融合应用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										><strong>四、新材料</strong></span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（一）金属材料</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 精品钢材制备技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>提高资源能源利用效率、促进减排的可循环钢铁流程技术；生态型非高炉炼铁技术，二次含铁资源和贫、难选铁矿的高效提取冶金技术，氧化物冶金技术，第三代TMCP技术，高合金钢铸轧一体化技术，薄带连铸产业化通用成套技术；高温合金制备技术；高附加值、特殊性能钢材、合金及制品的先进制备加工技术等。
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										不符合能耗及环保标准的中小规模烧结、球团、炼焦、炼铁、炼钢、铸造技术；普通热轧硅钢、工/中频感应炉生产的地条钢、普碳钢制备技术；常规用途的钢材机加工技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 铝、铜、镁、钛合金清洁生产与深加工技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>降低能耗和污染的清洁生产技术；熔体净化、高效熔炼、先进铸锻、半固态成形、连续近终成形、连续表面防腐/着色处理等高效生产技术和配套技术；高纯、高性能、环保的合金材料与合金材料制备及加工技术；宽幅薄板、精密箔带、高强高导铜合金、环保型合金制造技术，高性能预拉伸铝板带及铝焊丝、大型复杂截面、中空超薄壁型材、大型锻件、高精度管（棒、丝）材等高端产品的精深加工技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										不符合能耗和环保标准的冶炼技术；常规铝、铜、镁、钛合金生产与加工技术；常规电力、电工用金属导线和电缆漆包线生产与加工技术；通用铝建材和一般民用铝制品生产与加工技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 稀有、稀土金属精深产品制备技术
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>稀有、难熔高纯金属、高比容粉末提纯处理技术；钼、钽、铌材料的烧结及制备，宽幅板带箔材的成形技术；大型钨、钼异型件等静压成形加工技术；锆、铪高效洁净分离及锆合金包壳管精密铸轧加工技术；超细晶/超粗晶高性能硬质合金制品制备技术；降低稀土提纯过程污染和能耗的技术；稀土永磁体制造技术；高技术领域用稀土材料制备及应用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										普通玩具、音响、冶金机械等用NdFeB永磁体和初级出口磁体产品生产与加工技术；一般抗磨用途的硬质合金制品生产与加工技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 纳米及粉末冶金新材料制备与应用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>纳米材料与器件制备技术；超细、高纯、低氧含量、无/少夹杂金属粉末制备技术；粉末预处理、烧结预扩散、预合金化、球形化、包覆复合化先进制备技术；国产化配套关键零部件快速烧结致密化技术；高性能粉末钢热等静压/喷射沉积近终成形技术；新型铝及钛合金零件制备技术；高精密度金属注射成形（MIM）技术，新型高温合金、钛合金、微/共MIM及凝胶注模成形技术；增材制造金属新工艺、新材料制备及应用技术；高通量、高过滤精度、长寿命金属多孔材料制备及应用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										低压水/气自由式雾化粗粉制备技术；常规粉末冶金铁/铜基通用机械零件生产技术；进口喂料常规不锈钢、低合金钢MIM零件生产技术；粗过滤用铜基等多孔元件生产技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 金属及金属基复合新材料制备技术
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>低密度、高强度、高弹性模量、抗疲劳新型金属及金属基复合材料制备技术；耐磨、抗蚀、改善导电和导热等性能的金属基复合材料制备及表面改性技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										性能不可控的原位复合材料制备技术；常规颗粒和纤维增强复合材料制备技术；电弧/火焰喷涂、喷焊、镀锌、磷化、电镀等常规表面处理技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>6. 半导体新材料制备与应用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>石墨烯制备及应用技术；大尺寸硅单晶生长、晶片抛光片、SOI片及SiGe/Si外延片制备加工技术；大型MOCVD关键配套材料、硅衬底外延和OLED照明新材料制备技术；大尺寸砷化镓衬底、抛光及外延片、GaAs/Si材料制备技术；红外锗单晶和宽带隙单晶及外延材料制备技术；第三代宽禁带半导体材料制备技术；高纯金属镓、铟、砷、锗、磷、镉半导体蒸馏、区熔提纯大型连续化工艺技术，高纯及超高纯有色金属材料精炼提纯技术及痕量杂质测试技术；低污染硅烷法高纯度电子级多晶硅提纯、后处理、区熔规模化生产技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										高污染、高能耗、低光电转换效率的太阳能电池用单晶、多晶硅制备加工技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>7. 电工、微电子和光电子新材料制备与应用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型马达定子SMC软磁粉芯、SMD贴装电感软磁粉芯制备技术；高导磁、低功耗、抗电磁干扰软磁材料制备技术；高性能屏蔽材料技术，集成电路引线及引线框架技术，电子级无铅焊料技术，高导热、低膨胀电子封装与热沉材料技术，CMP抛光液技术，光刻配套超纯净微/纳孔净化分离膜技术，贱金属专用电子浆料技术，异形接触点和大功率无银触头技术，大尺寸高纯、高致密度新材料制备与应用技术；新型光、磁信息海量存储材料技术，光电子、光子晶体信息材料技术，智能传感器件用新材料制备与应用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										常规铁氧体、FeSiAl材料及制品、贵金属浆料制备技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>8. 超导、高效能电池等其它新材料制备与应用技术
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高温超导块材、线材、薄膜的制备与产业化应用技术；新型Fe基高温超导材料制备及其应用技术；高功率、高储能、高效能动力电池、轻质固态燃料电池、高效二次电池用新型隔膜、载体，金属双极板、储氢、吸气等新材料制备技术；超级电容材料制备与应用技术；良好生物相容性医用无镍不锈钢、钴基合金、β型钛合金、钛镍形状记忆合金、镁合金等新材料制备及其临床应用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 常规钴/镍/锰酸锂和磷酸铁锂材料制备技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（二）无机非金属材料</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 结构陶瓷及陶瓷基复合材料强化增韧技术
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>现代工业用陶瓷结构件制备技术；特殊用途的高性能陶瓷结构件制备技术；陶瓷基复合材料和超硬复合材料制备技术；陶瓷-金属复合材料制备技术；陶瓷纤维增强复合材料制备技术；多功能、多层结构复相陶瓷、碳化硅陶瓷的特种制备技术；超高温非氧化物陶瓷材料制备技术；耐磨损、耐高温涂层材料制备技术；特种涂料和涂层、特种晶体、特种功能陶瓷、高性能碳纤维和碳化硅纤维等材料及其复合材料制品制备技术；超硬材料及制品制备技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										常规工艺成型的传统结构陶瓷制备技术；挤出成型的蜂窝陶瓷蓄热体制备技术；高耗能电熔及熔铸材料制备技术；粘土砖、高铝砖等传统氧化物耐火材料制备技术；炉窑用常规浇注料制备技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 功能陶瓷制备技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>功能陶瓷的粉末制备、成型及烧结工艺控制技术，无铅化制备技术；新型高频高导热绝缘陶瓷材料制备技术；介电陶瓷和铁电陶瓷材料制备技术；各类敏感功能陶瓷材料制备技术；具有光传输、光存储等用途的光功能陶瓷及薄膜制备技术；高机电耦合系数、高稳定性铁电、压电晶体材料制备技术；特殊应用的光学晶体材料制备技术；超高温导电陶瓷发热材料制备技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 氧化铝、氧化锆、氧化铍陶瓷基板制备技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">3. 功能玻璃制备技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>光传输或成像等特殊功/性能玻璃或无机非晶态材料的制备技术；光电、压电、激光、耐辐射、闪烁体、电磁及电磁波屏蔽等功能玻璃制备技术；新型高强度玻璃制备技术；生物体和固定酶生物化学功能玻璃制备技术；滤光片、光学纤维面板、光学纤维倒像器、X射线像增强器微通道板新型玻璃制备技术；真空玻璃、在线low-E玻璃制备技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 用于功能玻璃生产的常规玻璃原材料制备技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 节能与新能源用材料制备技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>耐高温、抗腐蚀微孔多孔隔热材料制备技术；替代传统材料、显著降低能源消耗的无污染节能材料制造技术；炉窑免烘烤在线修补材料制备技术；新能源开发与利用相关的无机非金属材料制备技术；高透光新型透明陶瓷制备技术；低辐射镀膜玻璃及多层膜结构玻璃制备技术；高效保温材料制备技术；其他新机理的节能与新能源用材料制备技术。
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 环保及环境友好型材料技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>污水处理及烟气深度除尘用耐高温、抗酸碱的陶瓷膜制备技术；高温过滤及净化用低阻力降、高强度支撑体制备技术；具有重金属离子吸附功能的陶瓷材料制备技术；微孔与介孔陶瓷材料制备技术；环保用高比表面积无毒催化剂多孔陶瓷载体制备技术；含铬耐火材料的替代产品制备技术；易降解陶瓷纤维制备技术；其他新机理的环保及环境友好型材料制备技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										强度低于15MPa的碳化硅陶瓷膜支撑体制备技术；挤出成型水处理用氧化铝陶瓷支撑体制备技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（三）高分子材料</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 新型功能高分子材料的制备及应用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高分子分离膜材料制备技术；抗微生物高分子材料制备技术；高分子包装新材料制备技术；液晶高分子材料、形状记忆高分子材料、高分子相变材料、高分子转光材料、智能化高分子材料等新功能高分子材料制备技术；导电、抗静电、导热、阻燃、阻隔等功能高分子材料的高性能化制备技术；具有特殊功能、高附加值的高分子材料制备技术及以上材料的应用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 工程和特种工程塑料制备技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高强、耐高温、耐磨、超韧的高性能工程塑料和特种工程塑料分子的设计技术和改性技术；改性的工程塑料制备技术；具有特殊性能和用途的高附加值热塑性树脂制备技术；关键的聚合物单体制备技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 新型橡胶的合成技术及橡胶新材料制备技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>橡胶新品种的制备技术；接枝、共聚技术；卤化技术；特种合成橡胶材料技术；特种氟橡胶、硅橡胶、氟硅橡胶、氟醚橡胶、聚硫橡胶及制品制备技术；新型橡胶功能材料及制品制备技术；重大的橡胶基复合新材料技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 普通橡胶和仅以制品结构为特色的橡胶制备技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 新型纤维及复合材料制备技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型高性能纤维制备技术；成纤聚合物的接枝、共聚、改性及纺丝技术；具有特殊性能或功能化的聚合物、纤维材料、纤维制品及复合材料制备技术；环境友好、可降解、替代石油资源的新型生物质纤维制备技术，新型生物质纤维制品加工技术与装备制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*常规或性能仅略有改善的纤维制备技术；常规的非织造布、涂层布或压层纺织品、一般功能性纤维产品生产技术等除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 高分子材料制备及循环再利用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>生物降解塑料制备技术；生物质基高分子材料及其关键单体制备技术；以节约树脂为目标的低碳高分子材料制备技术；阻燃环保高分子泡沫材料制备技术；废弃橡胶、塑料、织物等材料的高值循环再利用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										50%以下填充聚烯烃普通改性材料（含崩解型材料）制备技术；淀粉填充聚烯烃的不完全降解塑料制备技术除外。
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>6. 高分子材料的新型加工和应用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高分子材料高性能化改性和加工技术；采用新型加工设备和加工工艺的共混、改性、配方技术；高比强度、大型、外型结构复杂的热塑性塑料制品制备技术；电纺丝等高分子材料加工技术；大型和精密橡塑设备加工设备和模具制造技术；增材制造用高分子材料制备及应用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										普通塑料和一般改性专用料加工技术；直接流延、吹塑、拉伸法塑料制品生产技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（四）生物医用材料</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 介入治疗器具材料制备技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>全降解冠脉支架、精微加工心血管植介入材料、具有特定治疗功能的外周血管支架及滤器、非血管管腔支架、减少介入损伤或具备治疗功能的介入导管、可降解介入封堵器、含药介入血管栓塞剂制备技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 心脑血管外科用新型生物材料制备技术
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>使用改性的新型材料编织的人工血管、生物复合型人工血管、新型覆膜血管制备技术；新型人工心脏瓣膜制备技术；颅骨修复材料和神经修复材料制备技术等。
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 骨科内置物制备技术
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>可注射陶瓷、可降解固定材料、新型低模量钛合金制备技术；医用镁合金等骨修复材料、脊柱修复材料和功能仿生型人工关节、表面生物功能化人工关节及制备技术；骨诱导功能人工骨、功能仿生型人工骨制备技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">4. 口腔材料制备技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>采用新型材料、表面处理技术或结构设计的牙种植体、具备高耐磨防继发龋等性能的复合树脂充填材料、非创伤性牙体修复材料(ART)、良好生物相容性临床修复效果佳的金属烤瓷制品和高精度硅橡胶类印模材料制备技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 组织工程用材料制备技术
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>组织器官缺损修复用可降解材料及仿生组织、器官制备技术；组织工程技术产品和组织诱导性支架材料制备技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>6. 新型敷料和止血材料制备技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>具备治疗或防感染功能的新型敷料、人工皮肤和使用方便的新型止血材料制备技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>7. 专用手术器械和材料制备技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>微创外科器械、手术各科专用或精细手术器械及外科手术灌洗液制备技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>8. 其他新型医用材料及制备技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高档次医用缝合线、新型人工晶体、智能型药物控释眼科植入材料及制品制备技术；生物相容性好、无或低副作用的新型整形用材料、新型手术后防粘连材料、新型计划生育用器材制备技术，其他新机理的新型医用材料及制备技术。
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（五）精细和专用化学品</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 新型催化剂制备及应用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型石油加工催化剂、有机合成新型催化剂、聚烯烃用新型高效催化剂、新型生物催化技术及催化剂、环保治理用新型和高效催化剂、催化剂载体用新材料及各种新型助催化材料等制备及应用技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 电子化学品制备及应用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>集成电路和分立器件用化学品、印刷线路板生产和组装用化学品、显示器件用化学品、彩色液晶显示器用化学品、印制电路板(PCB)加工用化学品、超净高纯试剂及特种（电子）气体、先进的封装材料和研磨抛光用化学品等制备及应用技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 超细功能材料制备及应用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>采用最新粉体材料的结构、形态、尺寸控制技术；粒子表面处理和改性技术；高分散均匀复合技术制备具有电子转移特性的有机材料技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 常规的粉体材料制备技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 精细化学品制备及应用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型环保型橡胶助剂、加工型助剂新品种、新型高效及复合橡塑助剂新产品、环境友好的新型水处理剂及其它高效水处理材料、新型造纸专用化学品、适用于保护性开采和提高石油采收率的新型油田化学品、新型表面活性剂、新型安全环保颜料和染料、新型纺织染整助剂、高性能环保型胶粘剂和高性能环境友好型皮革化学品制备及应用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*生物降解功能差或毒性大的表面活性剂制备技术；不符合环保标准的化学品制备技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（六）与文化艺术产业相关的新材料</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 文化载体和介质新材料制备技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>文化艺术用可再生环保纸（不含木料纸、新型非涂布纸和轻涂纸、轻质瓦楞纸板）、特种纸、电子纸等新型纸的制备技术；仿古纸的制备技术；光盘及原辅材料的制备技术；仿古墨的生产技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 艺术专用新材料制备技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>针对艺术专用品及改进其工艺生产的材料制备技术；针对艺术需要的声学材料的设计、加工、制作、制备等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 影视场景和舞台专用新材料的加工生产技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>用于与文化艺术有关的制景、舞台、影视照明的新型专用灯具器材的新材料、新工艺加工生产技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 文化产品印刷新材料制备技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>绿色环保数字直接制版材料，数字印刷用油墨、墨水，环保型油墨，特殊印刷材料等制备技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 文物保护新材料制备技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>文物提取、清洗、固色、粘结、软化、缓蚀、封护等材料的制备技术；文物存放环境的保护技术；用于古籍书画复制的制版和印刷材料开发技术；3D打印文物复制、修复技术及新材料制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										><strong>五、高技术服务</strong></span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（一）研发与设计服务</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 研发服务</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>面向企业和社会提供的基础性技术、应用开发技术、生产制造工艺技术；支撑经营管理和商业模式创新的关键技术等。
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 设计服务</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>面向行业应用的第三方工业设计、工程设计和专业设计技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>工业设计技术：精密复杂模具设计、工业产品设计、包装设计技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>工程设计技术：应用新技术、新工艺、新材料、新创意开展工程勘察、设计、规划编制、测绘、咨询服务的关键技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>专业设计技术：基于新创意、新技术、新工艺、新材料面向社会和生产生活提供服务的专业设计技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（二）检验检测认证与标准服务</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>具备相关权威机构资质认定或认可的第三方检验检测认证和标准化服务技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 检验检测认证技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>采用先进的方法、装备或材料，依据环境、安全、质量等相关标准、技术规范或其他强制性要求，开展面向设计开发、生产制造、售后服务全过程的检验、检测、认证等合格评定服务的关键支撑技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 标准化服务技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>面向企业、产业和社会提供技术标准的研发、咨询和第三方服务的关键支撑技术；行业标准数据库的二次开发与数据检索技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（三）信息技术服务</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>供方为需方提供开发、应用服务的关键技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 云计算服务技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">
										基于IaaS模式、SaaS模式和PaaS模式等云计算平台的运营服务技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 数据服务技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>面向行业和社会应用的基于大数据、知识库管理产品、商业智能（BI）的数据采集、分析处理与决策支持技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">3. 其他信息服务技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>IT规划设计和信息化建设技术，信息系统研发、测试和运行维护技术，智能化生产系统解决方案技术，网络信息安全服务及数据托管服务支撑技术，呼叫中心服务支撑技术，信息技术管理咨询、评估认证服务支撑技术，数据处理和存储服务支撑技术，数字内容加工处理服务支撑技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（四）高技术专业化服务</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于先进技术，为第三方提供专业化服务的关键技术。包括：为可再生能源、能量转换与储能装置及高效节能工艺技术、产品、设备提供检测、维护及系统管理服务的技术；环境监理、监测与检测、风险与损害评价、应急和预警服务技术；污水处理设施运营优化系统技术；卫星遥感服务、导航与位置服务和航空遥感服务的关键支撑技术；新材料检测、表征、评价、在线自动监测等服务的支撑技术；集成电路设计、测试与芯片制造服务的支撑技术；为企业提供的生物医药研发、食品质量安全标准品制备及检测、疾病预警预测和健康管理等服务的关键技术；智能制造和云制造服务的关键技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（五）知识产权与成果转化服务</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>采用新型服务模式和技术方法，提供知识产权的确权、检索、分析、诉讼、数据采集加工等基础性服务的支撑技术；提供知识产权增值性服务的支撑技术；提供专利数据库的二次开发建设与数据检索等服务的支撑技术；面向产业和企业提供技术转移转化、创业孵化、科技信息等服务的支撑技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（六）电子商务与现代物流技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 电子商务技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于第三方电子商务与交易服务平台的电子签名、电子认证、网络交易、在线支付、物流配送、信用评价等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 物流与供应链管理技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>集成物联网、自动化等技术，建立现代物流管理和供应链管理系统集成平台，面向不同领域和行业的企业提供的第三方物流运营和供应链管理技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										只具有企业内部物流管理系统、简单研发设计与低水平的重复性服务技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（七）城市管理与社会服务</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 智慧城市服务支撑技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于物联网、云计算、智能终端等技术，开展城市智能管理、城市感知认知、智慧决策等服务的支撑技术；城市数据支撑平台与智慧城市运营平台技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 互联网教育</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>应用互联网技术，创新服务模式和集成方案设计技术，面向个人、企业提供数字化学习资源和工具、智能设备和网络学习环境等服务的支撑技术；面向教育机构提供教育工具、教育平台运营及维护、内容制作及发布服务的支撑技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">3. 健康管理</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于信息网络技术，提供远程医疗护理、健康检测、卫生保健、康复护理服务、医疗健康的数字化诊疗诊断、智能化养老服务的支撑技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 现代体育服务支撑技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>运动营养、运动康复治疗、运动伤病防治、慢病的运动预防与干预技术；体育项目活动风险评估与安全保障技术；运动能力的开发与保障技术；运动与健身指导服务技术；反兴奋剂技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于互联网及人体动作识别、运动能量消耗评估的健身与监控设备开发技术；基于运动定位追踪的户外运动安全保障与应急救援平台开发技术；运动与游戏虚拟产品开发技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 一般体育产品生产开发和服务技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（八）文化创意产业支撑技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 创作、设计与制作技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>舞台美术、灯光、音响、道具、乐器、声学产品等的新技术及集成化舞台设计技术；数字电视、数字电影、数字声音、数字动漫、数字表演、数字体验等制作技术；虚拟现实、增强现实、三维重构等内容制作技术；文化体感支撑技术；网络视听新媒体及衍生产品开发支撑技术；艺术品鉴证技术；网络游戏引擎开发技术；网络游戏人工智能（AI）开发技术；其他支撑体现交互式、虚拟化、数字化、网络化特征的文艺创作、文化创意设计和产品制作技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 传播与展示技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型数字广播、电视、电影制作传输和播放技术、时空再现技术；移动多媒体广播（CMMB）技术；下一代广播电视网（NGB）技术；智能电视终端技术；出版物实时出版和交互式展示技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 院线利用相关技术进行服务除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 文化遗产发现与再利用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>文物发现、保护、修复、鉴定、原物识别的支撑技术；对不可移动文物、可移动立体文化资源、书画、非物质文化遗产等的数字化采集与处理技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">4. 运营与管理技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>后台服务和运营管理平台支撑技术；数字电视网与动漫制作基地管理支撑技术；文化信息资源共享支撑技术；数字版权保护技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										涉及色情、暴力、意识形态并造成文化侵蚀、有害青少年身心健康的除外；票务公司利用相关技术提供送票服务的除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										><strong>六、新能源与节能</strong></span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（一）可再生清洁能源</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 太阳能</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>太阳能热利用技术；太阳能光伏发电技术；太阳能热发电技术；其他新机理、高转化效率的太阳能利用技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 简单太阳能电池组件的封装和低水平的重复性生产除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 风能</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>大容量风电机组设计技术；海上风电技术；风电并网技术；风电场配套技术；风电蓄能技术；其他新机理、高转化效率的风能技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 不满足清洁生产要求的风电技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">3. 生物质能</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>生物质发电关键技术及发电原料预处理技术；生物质固体燃料致密成型及高效燃烧技术；生物质气化和液化技术；非粮生物液体燃料生产技术；生物质固体燃料高效燃烧技术；其他新机理、高转化效率的生物质能技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 不满足清洁生产要求的生物质燃烧技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 地热能、海洋能及运动能</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高效地热能发电技术；地热能综合利用技术；海洋能发电技术；其他新机理、高转化效率的地热能、海洋能及运动能技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（二）核能及氢能</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 核能</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>先进压水堆核电站关键技术，铀浓缩技术及关键设备、高性能燃料元件技术、铀钚混合氧化物燃料技术，先进乏燃料后处理技术，核辐射安全与监测技术，快中子堆和高温气冷堆核电站技术等。
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 氢能</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>天然气制氢技术，化工、冶金副产煤气制氢技术，低成本电解水制氢技术，生物质制氢、微生物制氢技术，金属贮氢、高压容器贮氢、化合物贮氢技术，氢加注设备和加氢站技术，超高纯度氢的制备技术，以氢为燃料的发动机与发电系统关键技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（三）新型高效能量转换与储存技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 高性能绿色电池（组）技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高性能绿色电池（组）技术；其它新型高性能绿色电池技术；先进绿色电池材料制造工艺与生产技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 新型动力电池（组）与储能电池技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>动力电池（组）技术；新型高性能炭铅动力电池（组）技术；液流储能电池技术；电池管理系统技术；动力与储能电池高性价比关键材料技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">3. 燃料电池技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>燃料电池催化剂技术；质子交换膜燃料电池技术；去质子膜燃料电池技术；直接醇类燃料电池技术；微型化燃料电池技术；中低温固体氧化物燃料电池技术；微生物燃料电池技术；光催化-燃料电池联用技术；燃料电池管理及工程技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 超级电容器与热电转换技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型高比能、高功率超级电容器技术，高性价比超级电容器关键材料及制备技术；热电材料及热电转换技术等。
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（四）高效节能技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 工业节能技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>煤的清洁高效利用技术；新型高效通用设备技术；新工艺节能技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 能量回收利用技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>钢铁企业余热回收利用技术；低温余热及高温固体余热回收利用技术；废弃燃气回收利用技术；蒸汽余压、余热、余能回收利用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										正常生产环节已回收利用技术和一般性高热值燃气发电技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">3. 蓄热式燃烧技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>工业炉窑和电站、民用锅炉的高效蓄热式燃烧技术等。
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 输配电系统优化技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>电能质量优化新技术，电网优化运行分析、设计、管理软件及硬件新技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">5. 高温热泵技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>地源、水源、空气源、太阳能复合式等高温热泵技术；空调冷凝热回收利用等技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">6. 建筑节能技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>绿色建筑设计技术，建筑节能技术，可再生能源装置与建筑一体化应用技术，精致建造和绿色建筑施工技术，节能建材与绿色建材的制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>7. 能源系统管理、优化与控制技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>工业、建筑领域的能源管理中心、能量系统优化设计、能源审计、优化控制、优化运行管理软件技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">8. 节能监测技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>自动化、智能化、网络化、功能全、测量范围广、适应性强的能源测量、记录和节能检测新技术；工业、建筑领域节能改造项目节能量检测与节能效果确认（M&amp;V）软件技术等。
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										><strong>七、资源与环境</strong></span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（一）水污染控制与水资源利用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 城镇污水处理与资源化技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>城镇生活污水高效低耗处理新技术；城市污水深度脱氮除磷及安全消毒处理技术；城市水循环利用技术；城市景观水体质量改善与维护技术；城镇垃圾渗滤液高效处理技术；医院污水处理新技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 工业废水处理与资源化技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>有毒有害与放射性工业废水处理技术；难降解有机废水处理技术；工业废水处理与资源化技术；高氨氮、高磷、高色度废水处理技术；高含盐废水与反渗透膜浓水处理技术；船舶压载水处理新技术；新型高效工业废水处理材料制备技术；高效无磷水处理药剂制备技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 农业水污染控制技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>农业施肥/施药等造成水体面源污染的控制技术；水产养殖水污染防治与循环利用技术；畜禽养殖场高浓度废水处理与资源化技术；农村小流域水污染综合整治技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 流域水污染治理与富营养化综合控制技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>流域分散点源和面源污染控制技术；流域目标水体的富营养化控制技术；水面浮油污染治理技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 节水与非常规水资源综合利用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>城市节水器具开发与应用技术；新型节水灌溉和旱作节水、农作物高效保水材料技术；水环境修复技术；雨水高效收集与利用技术；苦咸水、海水淡化利用技术及相关材料装备制造技术；高耗水行业节水减污技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>6. 饮用水安全保障技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>城镇饮用水源安全保障技术；城镇供水微污染控制技术；高效除藻及藻毒素处理技术；高级预氧化安全处理技术；高效混凝技术；高效吸附与过滤技术；饮用水消毒副产物检测与去除技术；农村饮用水安全保障技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（二）大气污染控制技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 煤燃烧污染防治技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>煤的低污染燃烧技术；高效低耗烟气脱硝、脱硫、除尘及除汞技术；烟气脱硫副产品综合利用技术；烟气中的细颗粒物高效分离技术；烟气中多污染物联合脱除技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 机动车排放控制技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>机动车排放颗粒物捕集器及再生技术；机动车尾气催化氧化与还原技术；汽油车排放污染控制技术和车载诊断（OBD）技术；柴油车污染排放控制技术；摩托车尾气净化技术，油气泄漏控制技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 工业炉窑污染防治技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>工业炉窑烟气脱硝技术、脱硫技术、除尘技术；工业炉窑烟气细颗粒物分离技术；工业炉窑烟气治理副产品资源化利用技术；炉窑烟气中多污染物联合脱除技术等。
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 工业有害废气控制技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>有机废气高效吸附与回收技术；有机废气高效低耗催化燃烧技术；恶臭废气收集与控制技术；二噁英产生控制与高效脱除技术；汞的减排与回收控制技术；其他工业有毒有害废气高效低耗净化技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 有限空间空气污染防治技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>公共场所室内空气污染防治技术；公共设施异味源防治技术；地下建筑空气污染防治技术；汽车隧道空气污染防治技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（三）固体废弃物处置与综合利用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 危险固体废弃物处置技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>危险固体废弃物高效焚烧技术；焚烧渣、飞灰、烧结灰和煅烧灰等处置技术；危险固体废弃物运输及安全填埋处置技术；危险废物固化技术；医疗废物收运与处置技术；有毒有害固体废弃物综合利用技术；放射性固体废弃物处置技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 工业固体废弃物综合利用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>工业固体废弃物无害化、减量化、资源化与综合利用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 生活垃圾处置与资源化技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>生活垃圾减量化与资源分类回收技术；利用水泥窑协同处置生活垃圾技术；大型生活垃圾焚烧污染控制、热能回收利用及尾气净化技术；填埋场气体回收利用技术；填埋场高效防渗技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 建筑垃圾处置与资源化技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>建筑垃圾的分类与再生料处理技术；建筑废物资源化再生关键技术；新型再生建筑材料应用技术；再生混凝土及其制品制备关键技术；再生混凝土及其制品施工关键技术；再生无机料在道路工程中的应用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 有机固体废物处理与资源化技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>农作物秸秆等有机固体废物破碎、分选等预处理技术；餐厨垃圾无害化与资源化技术；有机质固体废弃物无害化处置与资源化技术；有机质生活垃圾无害化、资源化技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>6. 社会源固体废物处置与资源化技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>废电池、废电器电子设备、废塑料、等社会源固体废物无害化处置与资源化技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（四）物理性污染防治技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 噪声、振动污染防治技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型吸声、隔声、隔振、减振材料制造技术；噪声、振动防治与控制技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 核与辐射安全防治技术
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>核设施安全风险控制技术；辐射源、辐射环境安全风险控制技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（五）环境监测及环境事故应急处理技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 环境监测预警技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>大气环境、水环境和噪声环境质量在线连续自动监测技术；大气、水、噪声污染源在线连续自动监测预警技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 应急环境监测技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>现场污染物快速测定技术；污染事故应急监测技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">3. 生态环境监测技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>环境遥感监测系统技术；海洋、农业、草原、森林生态环境监测技术；脆弱生态环境监测及灾害预警技术；重大自然灾害监测、预警和应急处置关键技术；转基因生物生态环境监测及灾害预警技术；敏感指示生物监测技术；生物入侵监测技术；生物多样性预警监测技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 非常规污染物监测技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>水、土壤、大气中非常规污染物分析监测与防治技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（六）生态环境建设与保护技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>地下水污染防治技术；土壤污染修复技术；防沙治沙、石漠化治理技术；河道生态修复、水土流失、土壤盐碱化防治等小流域综合整治技术；天然林保护、植被恢复和重建技术；湿地保护、恢复及相关监测技术；矿山环境损害评估、监测与恢复技术；小流域生态监测、功能恢复与重建技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（七）清洁生产技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 重污染行业生产过程中节水、减排及资源化关键技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>重污染行业的清洁生产新技术、新工艺；新型工业园区企业生产工艺流程的清洁生产设计关键技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 清洁生产关键技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高效短流程、无水（少水）纺织印染技术；清洁造纸技术；可循环钢铁冶炼流程工艺技术；清洁能源汽车生产技术；电厂海水循环冷却技术；高效洗煤、选煤技术；煤炭高效开采技术；煤液化、煤气化以及煤化工等转化技术；以煤气化为基础的多联产生产技术；重污染行业有毒有害原材料、溶剂和催化剂等的替代技术；臭氧层损耗物质替代新技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">3. 环保制造关键技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>环保基础材料制备技术，环保包装材料制备技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（八）资源勘查、高效开采与综合利用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 资源勘查开采技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>深地矿产资源立体探测、勘查、评价和开采技术；海洋矿产资源探测技术；非常规油气资源勘查、评价、钻探、开采和实验测试技术；天然气水合物勘查、开采技术；干热岩资源勘查与高温钻探技术；航空地球物理勘查技术；深穿透地球化学勘查技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 提高矿产资源回收利用率的采矿、选矿技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>深层和复杂矿体规模化开采技术；多金属硫化矿高效浮选分离综合回收选矿技术；细菌浸出技术；复杂难处理氧化矿中有价金属的高效低耗分离提取技术；新型高效浮选捕收剂、抑制剂和活化剂的合成与制备技术；采矿、选矿装备大型化、自动化、高效化和专用化技术；采矿、选矿生产过程自动检测和智能控制信息技术；难处理黑色金属矿综合利用新技术；非金属矿高效分离提纯和深加工新技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 伴生有价元素的分选提取技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>伴生贵金属、稀散元素的富集提取分离技术；伴生非金属矿物的回收、提纯、深加工技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 低品位资源和尾矿资源综合利用技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>低品位矿中有价元素的综合回收与分离提取技术；尾矿制粒堆浸技术；尾矿中有价元素二次富集综合回收技术；尾矿资源化稀有稀散组分实验测试与综合利用技术；低品位资源预富集新技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*常规工艺技术装备组合的“三废”处理技术；简单复配的水处理药剂与絮凝剂生产技术；未通过安全评价的用于治理环境污染的生物菌剂、物种等技术；存在二次污染又缺乏解决途径的技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 放射性资源勘查开发技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>铀矿攻深找盲技术；放射性资源分类技术，砂岩铀矿高效地浸采铀技术；铀煤及铀与其他共伴生资源协调开发综合利用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>6. 放射性废物处理处置技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>放射性废液处置技术；放射性固体废物处理处置技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">7. 绿色矿山建设技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>绿色矿山设计与施工技术，资源绿色开采技术，资源高效选冶技术，矿区生态高效修复技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										><strong>八、先进制造与自动化</strong></span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（一）工业生产过程控制系统</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 现场总线与工业以太网技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>符合国际、国内主流技术标准的现场总线技术；符合IEEE802.3国际标准的工业以太网技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 嵌入式系统技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于DSP、FPGA、CPLD、ARM等嵌入式芯片的各种高性能控制与传感器系统关键技术；用于流程工业的高性能测控系统、智能型执行器、智能仪表技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 新一代工业控制计算机技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>以Compact PCI、PXI、ATCA、PCI Express、PXI
										Express等总线技术为核心，可使用多种操作系统和图形编程语言，具有丰富的外部接口和“即插即用”功能，可构成安全性高、容错能力强的新一代高可用工业控制计算机的关键技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 制造执行系统（MES）技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>面向机械制造、汽车制造、石油加工、化学制品制造、金属冶炼等行业的制造执行系统技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 不具有通用性的应用软件除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 工业生产过程综合自动化控制系统技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于现场总线及工业以太网，面向连续生产过程、离散生产过程或混合生产过程的多功能组态软件、仿真技术与软件、具有冗余容错功能的综合自动化控制系统技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（二）安全生产技术 </span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 矿山安全生产技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>煤矿事故防控技术；非煤矿山事故防控技术；矿山事故应急救援技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 危险化学品安全生产技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>危险化学品生产与储运安全保障技术；典型石化过程安全保障技术；化工园区事故防控技术；危险化学品事故应急处置技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 其它事故防治及处置技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>冶金等工贸企业领域事故防治及应急处置技术；职业危害防治关键技术；智能安全监管执法技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（三）高性能、智能化仪器仪表</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 新型传感器</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>采用新原理、新材料、新工艺、新结构，具有高稳定性、高可靠性、高精度、智能化的新型传感器技术；新型电子皮肤传感器技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 采用传统工艺且性能没有提高的传感器除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 新型自动化仪器仪表</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>适用于实时在线分析、新型现场控制系统、e网控制系统、基于工业控制计算机和可编程控制的开放式控制系统及特种测控装备，能满足重大工程项目在智能化、高精度、高可靠性、大量程、耐腐蚀、全密封和防爆等特殊要求的新型自动化仪器仪表技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										技术含量低和精度低的传统流量、温度、物位、压力计或变送器除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 科学分析仪器/检测仪器</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>用于安全监控、产品质量控制的科学分析仪器和检测仪器技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 传统的气相色谱仪除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 精确制造中的测控仪器仪表</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>精密成形、超精密加工制造中的测控仪器仪表、亚微米到纳米级制造中的测控仪器仪表、激光加工中的测控仪器仪表、制造中的无损检测仪器仪表以及网络化、协同化、开放型的测控系统技术；裸眼3D膜质量检测仪器技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">5. 微机电系统技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>以微米、纳米加工技术为基础制造的，集微型机构、微型传感器、微型执行器以及信号处理和控制电路等于一体的微机电系统（MEMS）技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（四）先进制造工艺与装备</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 高档数控装备与数控加工技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高档数控系统、精密伺服驱动系统等高档数控设备关键功能部件及配套零部件技术；超精密数控机床、超高速数控机床、大型精密数控机床、多轴联动加工中心、高效精密立卧式加工中心、超硬材料特种加工机床等高端数控装备技术；高档数控装备关键功能部件和整机性能测试实验技术；大型特殊部件精密加工技术；兵器设计与制造先进技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 低端数控及应用系统除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 机器人</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>机器人伺服驱动系统、高精度减速器与绝对值编码器、开放式机器人控制器、视觉系统等工业机器人关键部件技术；先进工业机器人及自动化生产线技术；先进服务机器人及自动化生产线技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 四自由度以下的低端机器人系统除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 智能装备驱动控制技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高压、高频、大容量电力电子器件技术；智能型电力电子模块技术；大功率变频技术与大功率变频调速装置技术；高效节能传动技术与应用系统技术；用于各类专用装备的特种电机及其控制技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 采用通用电机的普通调速系统除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">4. 特种加工技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>激光器、大功率等离子束发生器、超高硬度刀具等特殊加工装备单元技术；激光加工技术；面向精密加工和特殊材料加工的特种加工技术；柔性印刷设备技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 大规模集成电路制造相关技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>大规模集成电路生产关键装备与制造技术；新型及专用部件设计与制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">6. 增材制造技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>基于三维数字化设计、自动化控制、材料快速堆积成形工艺的增材制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>7. 高端装备再制造技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>盾构机/TBM再制造技术；航空发动机关键件再制造技术；其他高端装备再制造技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（五）新型机械</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 机械基础件及制造技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>重要主机配套用的精密轴承制造技术；高性能、高可靠性、长寿命密封、传动、紧固、液压、气动类产品或元件制造技术；精密、复杂、长寿命、快速成型模具制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										常规通用工艺技术，结构、性能、精度、寿命一般的普通机械基础件、普通塑料模具和冷冲压模具除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 通用机械装备制造技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新型高性能流体混合、分离与输送机械制造技术；利用自动化控制和计算机信息管理等技术装备的起重运输、物料搬运等设备制造技术；特大型专用构件成形加工技术；其他新机理、节能环保型机械设备专用部件及动力机械技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 技术性能一般的各类普通机械装备制造技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 极端制造与专用机械装备制造技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>微纳机电系统、微纳制造、超精密制造、巨系统制造和强场制造相关的设计、制造工艺和检测技术；大型资源勘探开采、深海作业等专用功能机械装备制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										工作环境和技术性能一般的各类普通机械产品或装备除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 纺织及其他行业专用设备制造技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>与纺织机械及配套部件相关的高精度驱动、智能化控制、高可靠性技术；各类纺织设备的控制/计量/检测/调整的一体化集成技术；在线检测控制系统、高性能产品检测仪器的计算机和网络应用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 普通纺织机械及检测系统除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">（六）电力系统与设备</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 发电与储能技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>发电厂优化控制技术；火电厂自启停控制系统（APS）技术；发电机组新型励磁和调速技术；超导发电与储能技术；数字化量测、控制与保护技术；大规模可再生能源发电的接入技术及其与大规模储能联合运行技术；大规模间歇式能源发电实时监测技术；风电场、光伏电站集群控制系统技术；新型孤岛检测与保护技术、能量管理技术；不同储能系统的高效率智能化双向变流器、新型集中与分散孤岛检测、分散计量测控系统和中央测控系统技术等。
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 小型火力发电厂和小型水电站应用系统除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 输电技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>智能输电技术；柔性输电技术；高压交流输电系统串联补偿和并联补偿技术；低噪声导线、大截面导线、高强度节能型金具、新型避雷器、绝缘子等的制造技术；高压直流输电系统可控硅元件及换流器、换流变压器、直流套管、交/直流滤波器、平波电抗器、隔离刀闸与快速接地开关、避雷器等设备的制造技术，控制保护和测量设备技术；基于暂态行波等新型故障信息的继电保护和故障测距技术；大电网互联、远距离输电及其相关控制技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 传统的输电技术、常规的输电设备除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">3. 配电与用电技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>智能配用电技术；开关和开关柜集成技术；配电自动化和配电管理系统技术；高可靠性电缆、新型真空开关、先进节电装置的制造技术、先进无功功率补偿技术；节能节电控制装置及其综合管理系统技术；区域的在线动态谐波治理技术；电能质量检测、评估、控制与综合治理技术；用电信息新型采集技术；用户侧的智能表计及需求响应技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 不具有通用性的技术与产品除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">4. 变电技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>智能变电技术；气体绝缘金属封闭开关设备、高压组合电器、自能式六氟化硫(SF6)断路器、大容量变压器的制造技术；改进触头系统、传动系统或者具有高效防腐技术的新型高压隔离开关技术；高效节能变电站技术；采用现场总线技术、具有综合状态检测和网络通信功能的智能开关柜技术；具有控制、保护和监测功能的智能化终端装置技术；基于IEC61850通信协议的变电站综合自动化系统技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>*
										传统的高、低压开关设备，常规的发、供、配电设备除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 系统仿真与自动化技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>面向智能电网的电力系统数字物理混合仿真、全过程仿真技术；电力设备在线检测技术；电力系统虚拟仪器技术；电力系统调度自动化技术；电力设备管理及状态检修技术；继电保护信息管理及故障诊断专家系统技术；高速高可靠电力通信技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 不具有通用性的技术与产品除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（七）汽车及轨道车辆相关技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 车用发动机及其相关技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>先进汽车发动机零部件技术；车用发动机的清洁燃烧技术；先进车用发动机电子控制技术；车用发动机尾气排放净化技术和节能降耗技术；清洁代用燃料发动机技术；先进电控系统的传感器和执行器技术、发动机电控单元和匹配标定系统技术、柴油机电控高压共轨系统技术、发动机尾气排放控制系统技术、先进增压器及其控制系统技术、可变进气及其控制系统、可变气门正时与升程系统技术、发动机排气余热利用技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 技术性能一般的车用发动机技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 汽车关键零部件技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>汽车节能减排技术，先进汽车安全技术，汽车电子控制技术，汽车信息化和车联网技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>* 技术性能一般的汽车零部件技术除外。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>3. 节能与新能源汽车技术
									</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>新能源汽车整车设计、集成和制造技术，动力系统集成与控制技术，汽车计算平台技术，节能和新能源汽车的关键零部件先进技术；新型储能及其管理系统、车载及地面充电系统、动力耦合装置及电动辅助系统技术；新能源汽车试验测试及基础设施技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>4. 机动车及发动机先进设计、制造和测试平台技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>整车和发动机设计及性能分析软件，整车性能试验测试系统、交流电力测功机、汽车尾气排放检测分析系统、瞬时燃油计量和车载扭矩测试系统、发动机燃烧分析系统技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>5. 轨道车辆及关键零部件技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高速列车及城市轨道车辆转向架的先进设计、制造和测试技术，轻量化车体设计制造技术，轨道车辆转向架和车体减振降噪技术、牵引传动系统的先进设计、制造和测试技术，高速列车牵引变流技术、牵引控制系统技术、牵引变压系统技术、网络控制系统技术、总体集成技术、制动系统技术；混合动力动车组和机车的整车及转向架设计、集成和制造先进技术；大轴重机车和货车转向架的先进设计、制造和测试技术，万吨重载列车电控制动技术；快捷货车总体集成、车体及转向架技术；公路、铁路联运车辆关键及配套技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（八）高技术船舶与海洋工程装备设计制造技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>1. 高技术船舶设计制造技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>高技术、高附加值环保节能型船舶设计制造与节能减排系统技术。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>2. 海洋工程装备设计制造技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>海上工程作业与辅助服务装备、科学考察船、海洋调查船等勘探与开发装置、海洋矿产资源和天然气水合物等开采装备、海洋可再生资源开发装备、海水淡化、海上风电等新型海洋资源开发装备设计制造技术；船舶与海洋工程核心配套装备设计制造技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>（九）传统文化产业改造技术</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">1. 乐器制造技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>乐器及其器材加工和调试新技术；MIDI系统生产调试技术等。</span
									></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000">2. 印刷技术</span></span
								></span
							></span
						>
					</p>
					<p
						style="text-indent:2em;"
						size="0"
						_root="undefined"
						__ownerid="undefined"
						__hash="undefined"
						__altered="false"
					>
						<span style="line-height:1.5"
							><span style="font-size:16px"
								><span style="letter-spacing:1px"
									><span style="color:#000000"
										>改造传统印刷的高新技术；数字印刷技术；绿色印刷工艺技术；特种印刷工艺技术等。</span
									></span
								></span
							></span
						>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	methods: {
		goback() {
			this.$router.go(-1);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/form.scss";
</style>
